module.exports = __webpack_public_path__ + "img/354-fa45f1.png";